import {
  IFillDataWizardSell,
  TKeyOfDataWizardSell,
  TStringKeysOfIFillDataWizardSell,
} from "../..";
import DoNotKnowPriceSwapStep_1 from "../doNotNowPrice/swap/step_1";
import DoNotKnowPriceSwapStep_2 from "../doNotNowPrice/swap/step_2";
import DoNotKnowPriceSwapStep_3 from "../doNotNowPrice/swap/step_3";
import DoNotKnowPriceSwapStep_4 from "../doNotNowPrice/swap/step_4";
import DoNotKnowPriceSwapStep_5 from "../doNotNowPrice/swap/step_5";
import DoNotKnowPriceSwapStep_6 from "../doNotNowPrice/swap/step_6";

const getDoNotKnowSwapSteps = (
  data: IFillDataWizardSell,
  onReset: (keys: TKeyOfDataWizardSell[], data?: number[]) => void,
  handleChangeDataString: (
    data: string,
    key: TStringKeysOfIFillDataWizardSell
  ) => void,
  disabledAndPrev: {
    isNextStep_offersForClient: boolean;
    isNextStep_communicationType: boolean;
    isNextStep_viewRealtorParticipation: boolean;
    isNextStep_timeIntervalTypeCommunication: boolean;
  }
) => {
  const {
    isNextStep_offersForClient,
    isNextStep_communicationType,
    isNextStep_viewRealtorParticipation,
    isNextStep_timeIntervalTypeCommunication,
  } = disabledAndPrev;

  return [
    <DoNotKnowPriceSwapStep_1 />,
    <DoNotKnowPriceSwapStep_2
      data={data.communicationType}
      isNextStepDisabled={isNextStep_communicationType}
      onChange={handleChangeDataString}
      onReset={onReset}
    />,
    <DoNotKnowPriceSwapStep_3
      onChange={handleChangeDataString}
      data={data.timeIntervalTypeCommunication}
      isNextStepDisabled={isNextStep_timeIntervalTypeCommunication}
      onReset={onReset}
    />,
    <DoNotKnowPriceSwapStep_4
      onChange={handleChangeDataString}
      data={data.viewRealtorParticipation}
      isNextStepDisabled={isNextStep_viewRealtorParticipation}
      onReset={onReset}
    />,
    <DoNotKnowPriceSwapStep_5
      onChange={handleChangeDataString}
      data={data.offersForClient}
      isNextStepDisabled={isNextStep_offersForClient}
      onReset={onReset}
    />,
    <DoNotKnowPriceSwapStep_6 data={data} />,
  ];
};

export default getDoNotKnowSwapSteps;
